export default {
  methods: {
    defineDocumentDescriptionFromTag(tag) {
      console.log("DEFINE DOC TYPE");
      console.log(tag);
      if (tag === "U1") {
        // User
        return "User Detail"; // App Operations
      } else if (tag === "C1") {
        // Maint Assuracne
        return "AO";
      } else if (tag === "F1") {
        // Maint Assuracne
        return "AO";
      } else if (tag === "M1") {
        // Maint Assuracne
        return "BC";
      } else if (tag === "M2") {
        // Maint Strategy
        return "BC";
      } else if (
        // eslint-disable-next-line
        tag === "A1" ||
        tag === "O1" ||
        tag === "W1" ||
        tag === "E2"
      ) {
        return "BE";
      } else {
        return "NE";
      }
    }
  }
};
